module.exports = __webpack_public_path__ + "img/hand1.1507b7e3.png";